
  import { ref } from "vue";
  import { defineComponent } from 'vue';
  require('@tensorflow/tfjs-backend-cpu')
  require('@tensorflow/tfjs-backend-webgl')
  const cocoSsd = require('@tensorflow-models/coco-ssd')
  const video = document.getElementById("video") as HTMLVideoElement;
  const img = document.getElementById("video") as HTMLImageElement;
  export default defineComponent({
    name: 'App',
    setup(){
      const imgRef = ref(img);
      const isLoading = ref(false);
      const videoRef = ref<HTMLVideoElement>(video);
      const isStreaming = ref(false);
      const result = ref([]);
  
      async function detect() {
        const img = imgRef.value;
        const model = await cocoSsd.load();
        const predictions = await model.detect(img);
        result.value = predictions;
        isLoading.value = false;
        console.log(predictions, img);
      }  
      async function openCamera() {
        if (navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices.getUserMedia({video: true}).then((stream)=>{
             isStreaming.value = true;
             
            videoRef.value.srcObject = stream;
          })
        }
      }
      function stopStreaming() {
        const stream = videoRef.value.srcObject as MediaStream;
        const tracks = stream.getTracks();
        tracks.map((track) => track.stop());
        isStreaming.value = false;
      }
      function snapshot() {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
        ctx.drawImage(videoRef.value, 0, 0, 200, 200);
        const data = canvas.toDataURL("image/png");
        imgRef.value.setAttribute("src", data);
      }
    
      return {
        imgRef,
        detect,
        result,
        isStreaming,
        videoRef,
        openCamera,
        stopStreaming,
        snapshot,
      }
    }
  });
  